/**
 * resource component to display content module information in 
 * card form 
 * 
 * NOTE: unused in 1.15
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';
import { DateTime } from 'luxon';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import actions 
import * as contentModuleActions from '../../contentModule/contentModuleActions.js'; 

class OtherCertCard extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, certificate } = this.props; 
    dispatch(contentModuleActions.fetchSingleContentModuleById(certificate._contentModule)); 
  }

  render() {

    const {
      certificate
      , contentModuleStore
    } = this.props;
  
    const contentModule = certificate && contentModuleStore.byId[certificate._contentModule]; 

    const expirationDate = DateTime.fromISO(certificate.expires).toLocaleString(DateTime.DATE_MED)

    return (
      <div className="yt-col s_50 m_33 l_20">
      {/* Move all ReactTooltips to the root div of this component so that the stacking context allows the tooltip to display on top of everything else. */}
      { certificate && contentModule ? 
        <div id={`tm_${contentModule._id}`} className={`cert-card -${certificate.status}`}>
          <img src="/img/cert-item.jpg"/>
          <div className="-title"> {contentModule.title} </div>
          <div >
            <div className="yt-row center-vert space-between">
              <div className="yt-col bottom" style={{marginTop: '16px'}}>
                <div style={{marginBottom: '8px'}} className="-expires">Valid {certificate.expires ? `through ${expirationDate}` : null}</div>
                <Link className="-button" to={`/my-certificates/${certificate._id}`}>
                  Print Certificate
                </Link>
              </div>
            </div>
          </div>
        </div>   
      : null     
      }
      </div>
    )
  }
}

OtherCertCard.propTypes = {
  certificate: PropTypes.object.isRequired 
  , dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    contentModuleStore: store.contentModule
  }
}


export default withRouter(connect(mapStoreToProps)(OtherCertCard));



// WEBPACK FOOTER //
// modules/agenda/components/OtherCertCard.js.jsx